import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n-lite';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as drawerActions from '../../../actions/drawerActions';
import * as cookiesActions from '../../../actions/cookiesActions';
import * as accountActions from '../../../actions/accountActions';
import * as cookieUtils from '../../../utils/cookieUtils';
import { bindActionCreators } from 'redux';
import DrawerCommonPanel from '../../../components/drawer-contents/DrawerCommonPanel';
import CookiesMenuSwitch from '../../drawer-contents/CookiesMenuSwitch';
import { ROUTES } from '../../../const';
import { DD_CLIENT_ENABLED, NETEX_INFRA, GTM_ID } from '../../../config_module';
import { initCalendar } from '../../../utils/google/GCalendarUtils';
import TagManager from 'react-gtm-module';

class CookieMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoCookie: null,
      analyticsCookie: null,
      meetCookie: null
    };
  }

  componentDidMount() {
    const { user } = this.props;
    const videoCookie = cookieUtils.getVideoCookie(user);
    const meetCookie = cookieUtils.getMeetCookie(user);
    const analyticsCookie = cookieUtils.getAnalyticsCookie(user);
    if (!_.isNil(videoCookie)) {
      this.setState({
        videoCookie: videoCookie === 'true'
      });
    }
    if (!_.isNil(analyticsCookie)) {
      this.setState({
        analyticsCookie: analyticsCookie === 'true'
      });
    }
    if (!_.isNil(meetCookie)) {
      this.setState({
        meetCookie: meetCookie === 'true'
      });
    }
  }

  closeDrawer = () => {
    this.props.drawerActions.setDrawerClosed();
  };

  purgeCookiesAndLogout = async () => {
    cookieUtils.removeCookies(this.getCookieNames(), this.props.user);
    this.props.accountActions.logout();
  };

  setFalseConsentCookie = async () => {
    const { user } = this.props;
    cookieUtils.setConsentCookie(user, true);
    cookieUtils.setVideoCookie(user, false);
    cookieUtils.setAnalyticsCookie(user, false);
    cookieUtils.setMeetCookie(user, false);

    this.props.drawerActions.setDrawerClosed();
  };

  setConsentCookie = () => {
    const { user } = this.props;
    cookieUtils.setConsentCookie(user, true);
    cookieUtils.setVideoCookie(user, Boolean(this.state.videoCookie));
    if (this.state.analyticsCookie !== null || !_.isEmpty(this.props.trackingIdGAnalytics) || NETEX_INFRA)
      cookieUtils.setAnalyticsCookie(user, Boolean(this.state.analyticsCookie));

    if (this.state.meetCookie !== null || !_.isEmpty(this.props.googleMeetClientId)) {
      cookieUtils.setMeetCookie(user, Boolean(this.state.meetCookie));

      if (!this.state.meetCookie) {
        cookieUtils.removeMeetGenericCookies();
      } else {
        initCalendar();
      }

      this.props.cookiesActions.toggleMeetCookie();
    }

    if (this.state.meetCookie !== null || !_.isEmpty(this.props.jitsiDomain)) {
      cookieUtils.setMeetCookie(user, Boolean(this.state.meetCookie));
    }

    if (this.state.analyticsCookie && NETEX_INFRA && GTM_ID) {
      const tagManagerArgs = {
        gtmId: GTM_ID
      };
      TagManager.initialize(tagManagerArgs);
    } else {
      cookieUtils.removeAnalyticsGenericCookies();
    }
    this.props.drawerActions.setDrawerClosed();
  };

  getCookieNames = () => {
    return document.cookie.split(';').map(c => {
      return c.split('=')[0];
    });
  };

  render() {
    const { cookiesInfoUrl } = this.props;
    const ownCookiesChipList = [
      {
        name: I18n.t('panels.cookies.own'),
        removeCloseButton: true,
        linksTo: cookiesInfoUrl || `${ROUTES.COOKIES_DETAIL}#propias`
      }
    ];
    const meetCookies = [];

    if (this.props.googleMeetClientId) {
      meetCookies.push({
        name: 'Google Meet',
        removeCloseButton: true,
        linksTo: cookiesInfoUrl || `${ROUTES.COOKIES_DETAIL}#gMeet`
      });
    }

    if (this.props.jitsiDomain) {
      meetCookies.push({
        name: 'Jitsi Meet',
        removeCloseButton: true,
        linksTo: cookiesInfoUrl || `${ROUTES.COOKIES_DETAIL}#jitsiMeet`
      });
    }

    if (NETEX_INFRA) {
      ownCookiesChipList.push({
        name: 'Google SSO',
        removeCloseButton: true,
        linksTo: cookiesInfoUrl || `${ROUTES.COOKIES_DETAIL}#google_sso`
      });
      ownCookiesChipList.push({
        name: 'AWS',
        removeCloseButton: true,
        linksTo: cookiesInfoUrl || `${ROUTES.COOKIES_DETAIL}#aws`
      });
    }
    if (DD_CLIENT_ENABLED) {
      ownCookiesChipList.push({
        name: 'Datadog',
        removeCloseButton: true,
        linksTo: cookiesInfoUrl || `${ROUTES.COOKIES_DETAIL}#datadog`
      });
    }

    // El switch de analytics debe aparecer siempre si estamos en infra netex o si está seteado un ID de GA en otras infras
    const showAnalyticsSwitch = NETEX_INFRA || this.props.trackingIdGAnalytics;

    return (
      <DrawerCommonPanel
        sticky={false}
        panelHeaderTitle={I18n.t('panels.cookies.panelsHeaderTitle')}
        showCancelButton={true}
        hideRowButtons={false}
        secondaryButtonClasses={'cookies-cancel-button'}
        primaryButtonText={'panels.cookies.accept'}
        secondaryButtonText={'panels.cookies.rejectButton'}
        closePanel={this.closeDrawer}
        handleSecondaryButtonClick={this.setFalseConsentCookie}
        onPrimaryButtonClick={this.setConsentCookie}
        classes={'flexcolumn'}
      >
        <CookiesMenuSwitch
          disabled={true}
          cookiesInfoUrl={cookiesInfoUrl}
          checked={true}
          hideSwitch={!this.props.trackingIdGAnalytics && !this.props.googleMeetClientId}
          text={I18n.t('panels.cookies.functionalCookies')}
          subtext={I18n.t('panels.cookies.functionalCookiesDescription')}
          cssClass={'attach-file attach-element'}
          chipList={ownCookiesChipList}
        />

        <CookiesMenuSwitch
          checked={Boolean(this.state.videoCookie)}
          cookiesInfoUrl={cookiesInfoUrl}
          onChange={() => this.setState({ videoCookie: !this.state.videoCookie })}
          text={I18n.t('panels.cookies.videoCookies')}
          subtext={I18n.t('panels.cookies.videoCookiesDescription')}
          cssClass={'attach-file attach-element'}
          chipList={[
            { name: 'Youtube', removeCloseButton: true, linksTo: cookiesInfoUrl || `${ROUTES.COOKIES_DETAIL}#youtube` },
            { name: 'Vimeo', removeCloseButton: true, linksTo: cookiesInfoUrl || `${ROUTES.COOKIES_DETAIL}#vimeo` }
          ]}
        />

        {showAnalyticsSwitch && (
          <CookiesMenuSwitch
            checked={Boolean(this.state.analyticsCookie)}
            cookiesInfoUrl={cookiesInfoUrl}
            onChange={() => this.setState({ analyticsCookie: !this.state.analyticsCookie })}
            text={I18n.t('panels.cookies.analyticsCookies')}
            subtext={I18n.t('panels.cookies.analyticsCookiesDescription')}
            cssClass={'attach-file attach-element'}
            chipList={[
              {
                name: 'Google Analytics',
                removeCloseButton: true,
                linksTo: cookiesInfoUrl || `${ROUTES.COOKIES_DETAIL}#gAnalytics`
              },
              {
                name: 'Microsoft Clarity',
                removeCloseButton: true,
                linksTo: cookiesInfoUrl || `${ROUTES.COOKIES_DETAIL}#mClarity`
              }
            ]}
          />
        )}
        {meetCookies.length > 0 && (
          <CookiesMenuSwitch
            checked={Boolean(this.state.meetCookie)}
            cookiesInfoUrl={cookiesInfoUrl}
            onChange={() => this.setState({ meetCookie: !this.state.meetCookie })}
            text={I18n.t('panels.cookies.meetCookies')}
            subtext={I18n.t('panels.cookies.meetCookiesDescription')}
            cssClass={'attach-file attach-element'}
            chipList={meetCookies}
          />
        )}
        {NETEX_INFRA && (
          <div class="purgeCookie" onClick={this.purgeCookiesAndLogout}>
            <p>{I18n.t('panels.cookies.purgeAndLogout')}</p>
          </div>
        )}
      </DrawerCommonPanel>
    );
  }
}

CookieMenu.propTypes = {
  setConsentCookie: PropTypes.func,
  drawerActions: PropTypes.object,
  googleMeetClientId: PropTypes.string,
  jitsiDomain: PropTypes.string,
  trackingIdGAnalytics: PropTypes.string,
  cookiesActions: PropTypes.object,
  cookiesInfoUrl: PropTypes.string,
  user: PropTypes.object,
  accountActions: PropTypes.object
};

function mapStateToProps(state) {
  return {
    googleMeetClientId: state.account.configuration.meetClientId,
    jitsiDomain: state.account.configuration.jitsiDomain,
    trackingIdGAnalytics: state.account.configuration.trackingIdGAnalytics,
    cookiesInfoUrl: state.account.configuration.cookiesInfoUrl,
    user: state.account.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    drawerActions: bindActionCreators(drawerActions, dispatch),
    cookiesActions: bindActionCreators(cookiesActions, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CookieMenu);
